/* eslint-disable react/no-array-index-key */
import React, { FC, useEffect, useState } from 'react';
import { Col, Row, Radio } from 'antd';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import styled from 'styled-components';

import { PageHeader } from '~/layout';
import { usePath, usePermissions } from '~/hooks';
import { NoPermission } from '~/components';
import Accounts from './Accounts';
import OatAction from './OatAction';
import Filters from './Balances/Filters';
import Balances from './Balances/Balances';
import { useHistory } from 'react-router-dom';
import AccountFilters from './components/Filters';
import { invalidateAccountsPageQuery } from '~/hooks/accounts';

interface Props extends RouteComponentProps {
  className?: string;
}

const AccountsPage: FC<Props> = (props) => {
  const { className } = props;
  const [t] = useTranslation('accounts');
  const history = useHistory();
  const location = useLocation();

  const [viewMode, setViewMode] = useState<'accounts' | 'balances'>('accounts');

  const getViewModeFromPath = () =>
    location.pathname.endsWith('/balances') ? 'balances' : 'accounts';

  useEffect(() => {
    setViewMode(getViewModeFromPath());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleViewModeChange = (e: any) => {
    const mode = e.target.value;
    history.push(mode === 'balances' ? '/accounts/balances' : '/accounts');
  };

  const { changePath, params } = usePath();
  const handleChange = (values: Record<string, any>) => {
    changePath({ filter: values });
  };

  const hasAccessView = usePermissions('business.profile.view');
  if (!hasAccessView) return <NoPermission />;
  return (
    <div className={cx(className, 'AccountsPage')}>
      <Row gutter={gutter}>
        <Col span={24}>
          <PageHeader
            heading={t(viewMode)}
            showSearch={false}
            actions={
              viewMode === 'accounts' ? (
                <OatAction
                  reloadAccounts={() => {
                    invalidateAccountsPageQuery();
                  }}
                />
              ) : undefined
            }
          />
        </Col>
      </Row>
      <Row gutter={gutter} justify="space-between" align="middle" style={{ marginBottom: 8 }}>
        <Col>
          {viewMode === 'balances' && <Filters />}
          {viewMode === 'accounts' && (
            <AccountFilters onChange={handleChange} initialValues={params.filter} />
          )}
        </Col>
        <Col>
          <Radio.Group
            value={viewMode}
            onChange={handleViewModeChange}
            optionType="button"
            buttonStyle="outline"
            style={{ textAlign: 'right', flex: '1 1 auto', marginBottom: 8 }}
          >
            <Radio.Button value="accounts">{t('accounts')}</Radio.Button>
            <Radio.Button value="balances">{t('balances')}</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <div>{viewMode === 'balances' ? <Balances /> : <Accounts />}</div>
    </div>
  );
};

const gutter: [number, number] = [16, 24];

export default styled(AccountsPage)`
  padding-bottom: 24px;
  h5 {
    font-weight: 500;
  }
  .Profile-Table {
    padding: 1px;
  }
`;
